const LAST_ROUTE_KEY = 'exchange-last-route';
const UNLOAD_TIME_KEY = 'exchange-unload-time';
const SHOULD_RESTORE_KEY = 'exchange-should-restore';
const MARKET_ROUTE_PATTERN = /^\/exchange\/markets\/[^/]+$/;
const REFRESH_WINDOW_MS = 15000;

let unloadTrackingInitialized = false;

export const setupUnloadTracking = () => {
  if (unloadTrackingInitialized || typeof window === 'undefined') {
    return;
  }

  unloadTrackingInitialized = true;

  window.addEventListener('beforeunload', () => {
    sessionStorage.setItem(UNLOAD_TIME_KEY, String(Date.now()));
  });
};

export const captureRefreshIntent = () => {
  setupUnloadTracking();

  const unloadTime = sessionStorage.getItem(UNLOAD_TIME_KEY);
  sessionStorage.removeItem(UNLOAD_TIME_KEY);

  if (!unloadTime) {
    sessionStorage.setItem(SHOULD_RESTORE_KEY, 'false');
    return false;
  }

  const isRefresh = Date.now() - Number(unloadTime) < REFRESH_WINDOW_MS;
  sessionStorage.setItem(SHOULD_RESTORE_KEY, isRefresh ? 'true' : 'false');
  return isRefresh;
};

export const clearLastRoute = () => {
  localStorage.removeItem(LAST_ROUTE_KEY);
};

export const saveLastRoute = (pathname) => {
  if (MARKET_ROUTE_PATTERN.test(pathname)) {
    localStorage.setItem(LAST_ROUTE_KEY, pathname);
  } else if (pathname === '/') {
    clearLastRoute();
  }
};

export const getLastRoute = () => {
  const shouldRestore = sessionStorage.getItem(SHOULD_RESTORE_KEY) === 'true';
  sessionStorage.removeItem(SHOULD_RESTORE_KEY);

  if (!shouldRestore) {
    clearLastRoute();
    return '/';
  }

  const savedRoute = localStorage.getItem(LAST_ROUTE_KEY);
  if (savedRoute && MARKET_ROUTE_PATTERN.test(savedRoute)) {
    return savedRoute;
  }

  return '/';
};
